import { DecimalPipe } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemProgressComponent } from '../../components/item-progress/item-progress.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { PreVisitThankYouComponentComponent } from '../../components/pre-visit/thank-you/pre-visit-thank-you.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import SymptomCheckService from '../../services/symptom-check.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RestService from '../../services/core-rest.service';
import DialogServices from '../../services/dialog.service';
import BusinessRestServices from '../../services/business-rest.service';
import Session from '../../utils/session.service';
import PreVisitRecordTicketForPersonService from '../../services/pre-visit-record-ticket-for-person.service';
import PreVisitTicketFileService from '../../services/pre-visit-ticket-file.service';
import Config from '../../utils/config.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import moment from 'moment';
import { Input } from '@angular/core';
import { ModalConditionInfoComponent } from '../modal-condition-info/modal-condition-info.component';
import { ModalTreatmentGuidelineComponent } from '../modal-treatment-guideline/modal-treatment-guideline.component';
import { FileChangeDirective } from '../../directives/file-change.directive';

@Component({
	standalone: true,
	selector: 'symptom-check-results-pre-visit',
	templateUrl: './symptom-check-results-pre-visit.component.html',
	imports: [
		CommonModule, FileChangeDirective, DecimalPipe, TranslatePipe, 
		ItemProgressComponent, LoaderOverlayComponent, PreVisitThankYouComponentComponent,
		FormsModule
	]
})
export class SymptomCheckResultsPreVisitComponent implements OnInit, OnDestroy {
	private symptomCheckService: SymptomCheckService = inject(SymptomCheckService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private restService: RestService = inject(RestService);
	private dialogServices: DialogServices = inject(DialogServices);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private session: Session = inject(Session);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private preVisitTicketFileService: PreVisitTicketFileService = inject(PreVisitTicketFileService);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	@Input() settings: any;
	@Input() interview: any;
	@Input() problemDescription: any;
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.showCommunicationPreference = false;
		this.vm.showOnlyThankYouSection = false;
		this.vm.wantSickLeaveCertificate = false;
		this.vm.preferredCommunication = {};
		this.vm.preferredCommunication.phone = false;
		this.vm.preferredCommunication.video = false;
		this.vm.preferredCommunication.text = false;
		this.vm.preferredCommunication.inperson = false;
		this.vm.isSaving = false;
		this.vm.isPhotoUploadEnabled = this.config.getPreVisitConfig().PHOTO_UPLOAD_ENABLED;
		this.vm.selectedServiceIds = [];
		this.vm.required = {
			"MANDATORY": true,
			"ONE_IN_STEP": false
		};
		this.vm.isRecordTicketForPerson = false;
		
		var location: any = window.location.href;
		if (location.includes('eelvisiit')) {
			this.vm.iconSuffix = '-previsit';
		} else {
			this.vm.iconSuffix = '';
		}
		
		// TODO ANGULAR_2: validate this is needed
		var currentSelectedServiceIds = {};
		this.watcher = this.angularHelperService.createInterval(() => {
			var newSelectedServiceIds = this.vm.selectedServiceIds;
			if (!this.angularHelperService.isEqual(currentSelectedServiceIds, newSelectedServiceIds)) {
				currentSelectedServiceIds = Object.assign({}, newSelectedServiceIds);
				this.vm.required['ONE_IN_STEP'] = true;
				for (var selectedServiceId in this.vm.selectedServiceIds) {
					var id: any = this.vm.selectedServiceIds[selectedServiceId];
					if (!id) {
						delete this.vm.selectedServiceIds[selectedServiceId];
					}
					if (id) {
						for (var index in this.vm.serviceInfo) {
							var serviceSelectionElement: any = this.vm.serviceInfo[index];
							if (selectedServiceId == serviceSelectionElement.id && serviceSelectionElement.required === 'ONE_IN_STEP') {
								this.vm.required['ONE_IN_STEP'] = false;
							}
						}
					}
				}
			}
		}, 300);
		
		this.vm.preVisitType = 'NEW_HEALTH_PROBLEM'
		this.vm.thankYouInformationSection = this.thankYouInformationSection();
		this.vm.preVisitSettings = this.preVisitRecordTicketForPersonService.getSettings();
		if (this.vm.preVisitSettings 
			&& this.vm.preVisitSettings.preVisitNewHealthProblemConfig 
			&& this.vm.preVisitSettings.preVisitNewHealthProblemConfig === 'INFERMEDICA_SHOW_RESULTS') {
			this.vm.hideResults = false;
			this.vm.hideTriageResults = false;
		} else {
			this.vm.hideResults = true;
			this.vm.hideTriageResults = true;
		}
		
		this.vm.serviceInfo = this.vm.settings;
		this.vm.generalDescription = this.angularHelperService.trustAsHtml(this.angularFilterHelperService.translate('Symptom_Check.Results.Description'));
		this.vm.user = this.session.getSession().user;
		this.vm.origin = this.vm.user.origin;
		this.vm.otherDescriptionConf = this.angularFilterHelperService.filter(this.vm.serviceInfo, {fieldName: 'OTHER_DESCRIPTION'})[0];
		this.vm.additionalRequestOptions = this.angularFilterHelperService.filter(this.vm.serviceInfo, {fhirSection: 'SERVICE_REQUEST_ORDER_DETAILS'});
		this.vm.locationSelection = this.angularFilterHelperService.filter(this.vm.serviceInfo, {fhirSection: 'SERVICE_REQUEST_LOCATION_CODE'});
		this.vm.infermedicaId = this.angularFilterHelperService.filter(this.vm.serviceInfo, {fieldName: 'INFERMEDICA_INTERVIEW_ID'});
		this.vm.isRecordTicketForPerson = !!this.preVisitRecordTicketForPersonService.getPatient();
		
		this.getTriage()
			.then(() => {
				this.getTriageContent();
				return this.getOnDemandServiceSettings();
			})
			.then(() => {
				this.vm.isInitialized = true;
				this.angularHelperService.createTimer(() => { this.symptomCheckService.updateInterview({}); });
			})
			.catch(console.error);
		
		this.vm.openConditionInfo = this.openConditionInfo;
		this.vm.hasTreatmentGuideline = this.hasTreatmentGuideline;
		this.vm.openTreatmentGuideline = this.openTreatmentGuideline;
		this.vm.handleFormSubmit = this.submit;
		this.vm.goBackToMainPage = this.goBackToMainPage;
		
		this.vm.fileUpload = {
			files: []
		};
		this.vm.triggerFileSelectionDialog = this.triggerFileSelectionDialog;
		this.vm.uploadFile = this.uploadFile;
		this.vm.deleteFile = this.deleteFile;
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	submit(mainForm: any) {
		this.vm.submitted = true;
		var hasLocation = false;
		for (var i = 0; i < this.vm.locationSelection.length; i++) {
			var location = this.vm.locationSelection[i];
			if (this.vm.selectedServiceIds[location.id]) {
				hasLocation = true;
				break;
			}
		}
		this.vm.hasLocationSelected = hasLocation;
		if (mainForm.invalid || !hasLocation || this.vm.processing) {
			return;
		}
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		if (this.vm.isSaving) {
			return;
		}
		
		var ticketServiceRequestOptions: Array<any> = [];
		for (var selectedServiceId in this.vm.selectedServiceIds) {
			if (!this.vm.selectedServiceIds[selectedServiceId]) {
				continue;
			}
			for (var index in this.vm.serviceInfo) {
				var serviceSelectionElement: any = this.vm.serviceInfo[index];
				if (serviceSelectionElement.id == selectedServiceId && this.vm.selectedServiceIds[selectedServiceId]) {
					serviceSelectionElement.content = this.vm.selectedServiceIds[selectedServiceId];
					ticketServiceRequestOptions.push(serviceSelectionElement)
				}
			}
		}
		if (this.vm.otherDescriptionConf.content) {
			ticketServiceRequestOptions.push(this.vm.otherDescriptionConf);
		}
		if (this.vm.infermedicaId && this.vm.infermedicaId.length > 0 && this.vm.interview) {
			var infermedicaInterviewIdOption: any = this.vm.infermedicaId[0]
			infermedicaInterviewIdOption.content = this.vm.interview.localId;
			ticketServiceRequestOptions.push(infermedicaInterviewIdOption)
		}
		
		var submitData: any = {
			"type": this.vm.preVisitType,
			"selectedServiceRequestDetails": ticketServiceRequestOptions
		}
		if (this.vm.problemDescription) {
			submitData.freeTextProblemDescription = this.vm.problemDescription;
		}
		submitData = this.preVisitRecordTicketForPersonService.addRecordTicketForPersonData(submitData);
		if (this.vm.fileUpload.files && this.vm.fileUpload.files.length > 0) {
			submitData.preVisitTicketFiles = this.vm.fileUpload.files;
		}
		
		this.vm.isSaving = true;
		this.restService.savePreVisitNewHealthProblem(submitData)
			.then((response) => {
				this.vm.preVisitTicketId = response.id
				this.vm.showOnlyThankYouSection = true;
				this.vm.isSaving = false;
				deferred.resolve();
			})
			.catch((error) => {
				this.vm.isSaving = false;
				console.log(error);
			});
		
		return deferred.promise;
	}
	
	getTriage() {
		if (!this.vm.interview) {
			return this.angularHelperService.getPromise().resolve();
		}
		
		if (this.vm.interview.triage) {
			return this.angularHelperService.getPromise().resolve();
		}
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		var interview: any = this.angularHelperService.copy(this.vm.interview);
		interview.extras = { enableTriage5: true };
		
		var conditionRemoteIds: Array<any> = [];
		for (var conditionsKey in interview.diagnosis.conditions) {
			conditionRemoteIds.push(interview.diagnosis.conditions[conditionsKey].id);
		}
		
		this.restService.getConditionTreatmentGuidelines({conditionRemoteId: conditionRemoteIds})
			.then((response) => {
				this.vm.conditionTreatmentGuidelines = response;
			})
			.catch((error) => {
				console.log(error);
			});
		
		this.restService.saveTriage(interview)
			.then((res) => {
				this.vm.interview.triage = res;
				deferred.resolve();
			})
			.catch(console.error);

		return deferred.promise;
	}
	
	getTriageContent() {
		if (!this.vm.interview || !this.vm.interview.triage) return;
		
		switch (this.vm.interview.triage.triage_level) {
			case 'self_care':
			{
				this.vm.title = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Title.Self_Care');
				this.vm.description = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Description.Self_Care');
				this.vm.icon = 'home';
				this.vm.isCallEnabled = true;
				this.vm.level = 1;
				break;
			}
			case 'consultation':
			{
				this.vm.title = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Title.Consultation');
				this.vm.description = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Description.Consultation');
				this.vm.icon = 'phone';
				this.vm.isCallEnabled = true;
				this.vm.level = 2;
				break;
			}
			case 'consultation_24':
			{
				this.vm.title = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Title.Consultation_24');
				this.vm.description = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Description.Consultation_24');
				this.vm.icon = 'phone';
				this.vm.isCallEnabled = true;
				this.vm.level = 3;
				break;
			}
			case 'emergency':
			{
				this.vm.title = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Title.Emergency');
				this.vm.description = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Description.Emergency');
				this.vm.icon = 'emergency';
				this.vm.level = 4;
				break;
			}
			case 'emergency_ambulance':
			{
				this.vm.title = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Title.Emergency_Ambulance');
				this.vm.description = this.angularFilterHelperService.translate('Symptom_Check.Results.Triage.Description.Emergency_Ambulance');
				this.vm.icon = 'emergency';
				this.vm.level = 4;
				break;
			}
		}
	}
	
	getOnDemandServiceSettings() {
		if (!this.vm.isCallEnabled) {
			return this.angularHelperService.getPromise().resolve();
		}
		
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		var params: any = {
			origin: this.vm.origin
		};
		
		this.businessRestServices.getOnDemandSettings(params, (settings) => {
			var gmtHours: any = moment().utc().hours();
			var currencies: any = { 'EUR': '€', 'USD': '$', 'GBP': '£', 'PLN': 'zł‎', 'RUB': '₽', 'SEK': 'kr', 'DKK': 'kr.', 'NOK': 'kr'  };

			this.vm.service = settings.filter(function(item) {
				return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && item.furtherSubcategory === 'FAMILY_PHYSICIAN';
			})[0];
			this.vm.buttonText = this.angularFilterHelperService.translate('Symptom_Check.Results.Button')
				.replace('%s', this.vm.service.price)
				.replace('%s', currencies[this.vm.service.currency])
				.replace('%s', this.vm.service.timePerPrice);
			this.vm.isServiceAvailable = !this.vm.service.onHold
				&& (!this.vm.service.startTimeInHours || gmtHours >= this.vm.service.startTimeInHours)
				&& (!this.vm.service.endTimeInHours || gmtHours < this.vm.service.endTimeInHours);
			
			deferred.resolve();
		});
		
		return deferred.promise;
	}
	
	openConditionInfo(condition) {
		if (!condition) return;
		
		this.dialogServices.show({
			controller: ModalConditionInfoComponent,
			condition: condition,
			interview: this.vm.interview
		});
	}
	
	hasTreatmentGuideline(conditionId) {
		for (var index in this.vm.conditionTreatmentGuidelines) {
			if (this.vm.conditionTreatmentGuidelines[index].conditionRemoteId === conditionId) {
				return true;
			}
		}
		return false;
	}
	
	openTreatmentGuideline(conditionId) {
		var guideline: any = undefined;
		for (var index in this.vm.conditionTreatmentGuidelines) {
			if (this.vm.conditionTreatmentGuidelines[index].conditionRemoteId === conditionId) {
				guideline = this.vm.conditionTreatmentGuidelines[index];
			}
		}
		if (!guideline) {
			return;
		}
		var options: any = {
			title: guideline.conditionName,
			text: guideline.guidelines
		}
		this.dialogServices.show({
			controller: ModalTreatmentGuidelineComponent,
			options: options
		});
	}
	
	goBackToMainPage() {
		var dialog = this.dialogServices.confirmation({
			content: this.angularFilterHelperService.translate('Symptom_Check.Results.Dont_Forward_Confirmation_Text')
		});
		dialog.afterClosed().subscribe((modalResponse) => {
			if (modalResponse && modalResponse.isAccepted) {
				this.angularRoutingHelperService.setPath('/', false, false, {});
			}
		});
	}
	
	thankYouInformationSection() {
		var translatedSection: any = "<p>" + this.angularFilterHelperService.translate('PreVisit.Symptom_Check_Results.Application_Forwarded') + "</p>";
		if (this.vm.level === 1) {
			translatedSection += "<p>" + this.angularFilterHelperService.translate('PreVisit.Symptom_Check_Results.Contacted_In_Level_1') + "</p>";
		} else if (this.vm.level === 2) {
			translatedSection += "<p>" + this.angularFilterHelperService.translate('PreVisit.Symptom_Check_Results.Contacted_In_Level_2') + "</p>";
		} else if (this.vm.level === 3) {
			translatedSection += "<p>" + this.angularFilterHelperService.translate('PreVisit.Symptom_Check_Results.Contacted_In_Level_3') + "</p>";
		} else if (this.vm.level === 4) {
			translatedSection += "<p>" + this.angularFilterHelperService.translate('PreVisit.Symptom_Check_Results.Contacted_In_Level_4') + "</p>";
		}
		return translatedSection;
	}
	
	triggerFileSelectionDialog() {
		var inputElement: any = document.getElementById('fileInput');
		inputElement ? inputElement.click() : undefined;
	}
	
	uploadFile = ($event, files): void => {
		this.vm.isProcessing = true;
		this.preVisitTicketFileService.uploadPrevisitPicture(
			this.vm.user.id,
			files[0],
			(response) => {
				console.log(response);
				this.vm.isProcessing = false;
				this.vm.fileUpload.files.push({
					id: response.id,
					originalFileName: response.originalFileName
				})
			}, (error) => {
				console.error(error);
			});
	}
	
	deleteFile(file) {
		this.vm.isProcessing = true;
		this.preVisitTicketFileService.deletePrevisitPicture(
			file.id,
			(response) => {
				this.vm.isProcessing = false;
				this.vm.fileUpload.files = this.vm.fileUpload.files.filter(function(item) {
					return item.id !== file.id;
				});
			},
			(error) => {
				console.error(error);
			});
	}
	
}